export default class Base {
  constructor(options) {
    Object.assign(this, { ...options });
    delete this.__v;
    delete this._id;
  }
}
